import http from 'utils/http';
import {
  getThirdPartyIntegrationsUrl,
  toggleThirdPartyIntegrationUrl,
  updateThirdPartyIntegrationUrl
} from './apiUrls';
import {
  ThirdPartyIntegrationState,
  ToggleThirdPartyIntegrationPayload,
  UpdateThirdPartyIntegrationPayload
} from './types';

export function getThirdPartyIntegrations(): Promise<ThirdPartyIntegrationState[]> {
  return http.get(getThirdPartyIntegrationsUrl());
}

export function updateThirdPartyIntegration(
  provider: string,
  payload: UpdateThirdPartyIntegrationPayload
): Promise<ThirdPartyIntegrationState> {
  return http.put(updateThirdPartyIntegrationUrl(provider), payload);
}

export function toggleThirdPartyIntegration(
  provider: string,
  payload: ToggleThirdPartyIntegrationPayload
): Promise<ThirdPartyIntegrationState> {
  return http.patch(toggleThirdPartyIntegrationUrl(provider), payload);
}
